import svg4everybody from 'svg4everybody';
import EnhancerApp from '../enhancer-app';
import '../enhancers/article-body';
import '../enhancers/toggle-menu-button-style';
import '../enhancers/nav-pane';
import '../enhancers/dismissable-alert';
import '../enhancers/load-more-button';
import '../enhancers/progress-button';
import '../enhancers/region-selector';
import '../enhancers/event-calendar';
import '../enhancers/ics-file';

// HTML has loaded
document.addEventListener(
    'DOMContentLoaded',
    () => {
        svg4everybody();
        EnhancerApp.start();
    },
    false
);

// Images, etc has loaded
window.addEventListener('load', () => {
    // Add code here
});
